import { render, staticRenderFns } from "./EmptySidebar.vue?vue&type=template&id=fd169b0a&scoped=true"
import script from "./EmptySidebar.vue?vue&type=script&lang=ts"
export * from "./EmptySidebar.vue?vue&type=script&lang=ts"
import style0 from "./EmptySidebar.vue?vue&type=style&index=0&id=fd169b0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd169b0a",
  null
  
)

export default component.exports